// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
define('login_config', [], function(){
    return {cp_url: '/cp', url_prefix: '/sdk_api', is_sdk_cp: true};
});
